// 關於我們 intro
'use client';
import { CRYPTO_CITY_OFFICIAL_URL } from '@/common/constant';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';

const AboutIntro = () => {
    const { t } = useTranslation();

    return (
        <section className="relative z-[1] w-full mt-[50px] space-y-[35px] ulg:mt-[36px]">
            <div className="noScrollX w-screen relative left-[50%] translate-x-[-50%]">
                <div className="justify-center gap-x-[11px] [&>div]:w-[304px] mx-auto flex ulg:justify-start">
                    {new Array(3).fill(0).map((_, i) => (
                        <div
                            className="flex-shrink-0 rounded-[4px] bg-white px-[28px] py-[13px] space-y-[15px] text-center border border-[#f7f7f8] dark:border-[#393939]"
                            key={'intro' + i}
                        >
                            <p className="text-bd1b text-jblack">{t('INTRO_' + i)}</p>
                            <div className="img-box w-full aspect-[250/193] after:content-none">
                                <Image
                                    width={250}
                                    height={193}
                                    src={`/images/about/intro_${i + 1}.svg`}
                                    alt="intro"
                                />
                            </div>
                            <p className="text-bd4n text-jblack">{t('INTRO_E_' + i)}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div
                className="space-y-[10px] relative w-full mx-auto [&>a]:rounded-[8px] [&>a]:bg-white [&>a]:border-1 [&>a]:border-[#f7f7f8]
            dark:[&>a]:border-[#393939] [&>a]:px-[40px] [&>a]:py-[30px] [&>a]:flex [&>a]:items-center [&>a]:gap-x-[40px] [&>a]:trans
            umd:[&>a]:flex-col umd:[&>a]:gap-y-[40px] umd:[&>a]:pt-[40px] usm:[&>a]:px-[15px] usx:[&>a]:rounded-[0]  usx:[&>a]:border-l-0 usx:[&>a]:border-r-0
            usx:w-screen usx:left-[50%] usx:translate-x-[-50%]"
            >
                <a
                    target="_blank"
                    rel="noreferrer noopener"
                    href={CRYPTO_CITY_OFFICIAL_URL.CS}
                    className="hover:border-[#c7c7c7] dark:hover:border-[#636363]"
                >
                    <div className="img-box w-[180px] h-[24px] after:content-none flex-shrink-0">
                        <Image
                            className="dark:hidden"
                            width={180}
                            height={24}
                            src="/images/about/cs_logo.svg"
                            alt="logo"
                        />
                        <Image
                            className="hidden dark:block"
                            width={180}
                            height={24}
                            src="/images/about/dark_cs_logo.svg"
                            alt="logo"
                        />
                    </div>

                    <div className="space-y-[10px]">
                        <p className="text-bd1b text-jblack">・ {t('CS_TITLE')}</p>
                        <p className="text-bd1m text-black9">{t('CS_CONTENT')}</p>
                    </div>
                </a>

                <a
                    target="_blank"
                    rel="noreferrer noopener"
                    href={CRYPTO_CITY_OFFICIAL_URL.CR}
                    className="hover:border-[#c7c7c7] dark:hover:border-[#636363]"
                >
                    <div className="img-box w-[180px] h-[18px] after:content-none flex-shrink-0">
                        <Image
                            className="dark:hidden"
                            width={180}
                            height={18}
                            src="/images/about/cr_logo.svg"
                            alt="logo"
                        />
                        <Image
                            className="hidden dark:block"
                            width={180}
                            height={18}
                            src="/images/about/dark_cr_logo.svg"
                            alt="logo"
                        />
                    </div>

                    <div className="space-y-[10px]">
                        <p className="text-bd1b text-jblack">・ {t('CR_TITLE')}</p>
                        <p className="text-bd1m text-black9">{t('CR_CONTENT')}</p>
                    </div>
                </a>
            </div>
        </section>
    );
};

export default AboutIntro;
